/* eslint-disable react/jsx-props-no-spreading */
import styled, { css } from "styled-components";
import React from "react";
import handleSpaces, { spacingProps } from "../utils/handleSpaces";

const withSpacing = (Component) => (props) => {
  const spacing = spacingProps(props);

  const WithSpacingComponent = styled(Component).attrs((componentProps) => ({
    ...componentProps,
    ...spacing,
  }))`
    ${(componentProps) =>
      css`
        ${handleSpaces(componentProps)}
      `}
  `;

  return <WithSpacingComponent {...props} />;
};

export default withSpacing;
